import { client } from "./supabase";

export const getFotosBySaleId = async (saleId) => {
  const { data, error } = await client
    .from("reportes_fotograficos")
    .select("*")
    .eq("sale_id", saleId)
    .order("idedificio")
    .order("created_at", { ascending: true });
  if (error) throw error;
  return data || [];
};

export const getReportesBySaleIds = async (saleIds) => {
  if (!saleIds?.length) return [];
  const { data, error } = await client.from("reportes_fotograficos").select("sale_id, id").in("sale_id", saleIds);
  if (error) throw error;
  return data || [];
};

export const uploadFotoReporte = async (file, { sale_id, idedificio, created_by }) => {
  const ext = file.name.split(".").pop().toLowerCase();
  const path = `reportes/${sale_id}/${idedificio}_${Date.now()}.${ext}`;
  const { error: uploadError } = await client.storage.from("galeria").upload(path, file);
  if (uploadError) throw uploadError;
  const { data: urlData } = client.storage.from("galeria").getPublicUrl(path);
  const url = urlData.publicUrl;
  const { data, error: insertError } = await client
    .from("reportes_fotograficos")
    .insert([{ sale_id, idedificio, url, created_by }])
    .select();
  if (insertError) throw insertError;
  return data?.[0];
};

export const deleteFotoReporte = async (fotoRecord) => {
  const url = new URL(fotoRecord.url);
  const pathMatch = url.pathname.match(/\/storage\/v1\/object\/public\/galeria\/(.+)/);
  if (pathMatch) {
    const storagePath = decodeURIComponent(pathMatch[1]);
    await client.storage.from("galeria").remove([storagePath]);
  }
  const { error } = await client.from("reportes_fotograficos").delete().eq("id", fotoRecord.id);
  if (error) throw error;
};
